module.exports = __webpack_public_path__ + "static/healthcare-b2a48b7eca2cad933283f228be322664.jpg";